import i18n from 'i18next';

class UserService {
  private static _instance: UserService = new UserService();
  constructor() {
    if (UserService._instance) {
      throw new Error('Error: Instantiation failed: Use SingletonClass.getInstance() instead of new.');
    }
    UserService._instance = this;
  }

  public static getInstance(): UserService {
    return UserService._instance;
  }

  public getUserName() {
    const userId = i18n.t('userName');
    return userId;
  }

  public getEmail() {
    return this.getUserName()?.replace(/\s/g, '') + '@smartims.com';
  }

  public getUserNameWithID() {
    const userId = i18n.t('userName');
    return userId;
  }
}
export default UserService;
